import { useGetPlaceQuery } from "place/api/place.api";
import { useParams } from "react-router-dom";

import { PlaceAdminForm } from "../components/forms/PlaceAdminForm";

import QueryWrapper from "common/components/QueryWrapper";

export function PlaceAdminView({ isCreateMode }: { isCreateMode: boolean }) {
  const { placeId } = useParams<{ placeId: string }>();

  const query = useGetPlaceQuery(placeId!, {
    skip: !placeId,
  });

  return (
    <>
      {placeId ? (
        <QueryWrapper query={query}>
          {(place) => <PlaceAdminForm place={place} editMode={true} />}
        </QueryWrapper>
      ) : (
        <PlaceAdminForm editMode={false} />
      )}
    </>
  );
}
